export function getStorage(key) {
    const date = new Date()
    const current = Math.round(date / 1000)
    let expires = localStorage.getItem(key + '.expires')

    if (!expires) expires = 0

    if (expires < current) {
        localStorage.removeItem(key)
        localStorage.removeItem(key + '.expires')
    }

    return localStorage.getItem(key)
}

export function setStorage(key, content, expires) {
    if (!expires) expires = 24 * 3600

    const date = new Date()
    const schedule = Math.round((date.setSeconds(date.getSeconds() + expires)) / 1000)

    localStorage.setItem(key, content)
    localStorage.setItem(key + '.expires', schedule)
};

export function delStorage(key) {
    localStorage.removeItem(key)
    localStorage.removeItem(key + '.expires')
}

export function getUrlParameter(parameterName) {
    const result = null
    let tmp = [];
    const items = location.search.substr(1).split("&");
    
    for (let index = 0; index < items.length; index++)
    {
        tmp = items[index].split("=");
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    }
    
    return result;
};
